<template>
  <div class="tabContent">
    <vxe-toolbar v-if="isEdit">
      <template v-slot:buttons>
        <vxe-button
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          @click="batchPicking()"
          >{{ $t('salesBill.batchMatchingResults.button.batchPicking') }}</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-grid
      border
      resizable
      show-overflow
      :data="storageLadingPicking"
      :edit-config="editConfig"
      size="mini"
      ref="goodsTable"
      :edit-rules="goodsTableRules"
      :columns="columnList"
      auto-resize
      :max-height="$store.state.app.tableHeight"
      :valid-config="{ autoPos: true, message: 'inline' }"
      keep-source
    >
    </vxe-grid>
    <!-- 拣配结果表格 -->
    <div style="margin-top: 10px">
      <span>{{ this.$t('salesBill.batchMatchingResults.title.result') }}</span>
      <vxe-table
        border
        resizable
        show-overflow
        :data="storageLadingPickingDetailList"
        :edit-config="editConfigPickingDetail"
        :max-height="$store.state.app.tableHeight"
        size="mini"
        ref="resultTable"
        :edit-rules="feeFormRules"
        auto-resize
        keep-source
        :valid-config="{ autoPos: true, message: 'inline' }"
      >
        <vxe-table-column
          type="index"
          width="50"
          :title="this.$t('salesBill.batchMatchingResults.table.seq')"
        ></vxe-table-column>
        <vxe-table-column
          field="inboundPickNo"
          title="原材料行项目号"
          width="60"
        ></vxe-table-column>
        <vxe-table-column field="productDesc" title="原材料描述" width="150"></vxe-table-column>
        <vxe-table-column field="productNo" width="120" title="原材料编码"></vxe-table-column>
        <vxe-table-column
          field="ladingUnitName"
          width="60"
          :title="this.$t('salesBill.batchMatchingResults.table.ladingUnitName')"
        ></vxe-table-column>
        <vxe-table-column
          field="outboundStorageName"
          width="140"
          title="拣配仓库"
        ></vxe-table-column>
        <vxe-table-column
          field="pickingQuantity"
          width="100"
          :title="this.$t('salesBill.batchMatchingResults.table.pickingQuantity')"
        ></vxe-table-column>
        <vxe-table-column
          field="actualSendQuantity"
          :title="this.$t('salesBill.batchMatchingResults.table.invoiceDate')"
          width="100"
        ></vxe-table-column>
        <vxe-table-column field="businessContractUnitPrice" title="物料非含税单价" width="140">
          <template v-slot="{ row }">
            {{ row.businessContractUnitPrice | formatTableColumn('formatPrice') }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="businessPickingAmount"
          width="140"
          :title="this.$t('salesBill.batchMatchingResults.table.businessPickingAmount')"
        >
          <template v-slot="{ row }">
            {{ row.businessPickingAmount | formatTableColumn('formatAmountRound') }}
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column
          field="distributionBatchNo"
          :title="this.$t('salesBill.batchMatchingResults.table.distributionBatchNo')"
        ></vxe-table-column> -->
        <vxe-table-column
          field="supplier"
          width="160"
          :title="this.$t('salesBill.batchMatchingResults.table.supplier')"
        ></vxe-table-column>
        <vxe-table-column
          field="businessInboundBatchNo"
          :title="this.$t('salesBill.batchMatchingResults.table.businessInboundBatchNo')"
          width="120"
        ></vxe-table-column>
      </vxe-table>
    </div>
    <batch-picking-dialog
      ref="batchPickingDialog"
      :numObj="numObj"
      :storageLadingPickingDetailList="storageLadingPickingDetailList"
      :basicData="basicData"
      @changeResult="changeResult"
    ></batch-picking-dialog>
  </div>
</template>

<script>
  import API from '@/api/purchaseSalesCenter/salsManage/salesLadingbill.js';
  import batchPickingDialog from './batchPickingDialog';
  // import inputNumber from '@/components/form-item/input-number';
  import { toFixedNumber } from '@/common/js/util';
  import XEUtils from 'xe-utils';

  export default {
    props: {
      storageLadingPickings: {
        type: Array,
        default: () => [],
      },
      storageLadingPickingDetail: {
        type: Array,
        default: () => [],
      },
      isEdit: {
        type: Boolean,
        default: () => true,
      },
      basicData: {
        type: Object,
        default: () => {},
      },
      deliveryMethod: {
        type: String,
        default: '',
      },
      editConfigFlag: {
        type: Boolean,
        default: () => false,
      },
    },
    watch: {
      storageLadingPickings() {
        this.storageLadingPicking = this.storageLadingPickings;
      },
      storageLadingPickingDetail(val) {
        this.storageLadingPickingDetailList = val;
      },
      basicData(val) {
        this.basicData = val;
      },
    },
    components: {
      batchPickingDialog,
      // inputNumber,
    },
    data() {
      return {
        feeFormRules: {},
        tableToolbar: {},
        editConfig: {},
        editConfigPickingDetail: {},
        // basicData: {},
        storageLadingPicking: [],
        storageLadingPickingDetailList: [], //结果明细
        numObj: {
          hasPickedAmount: 0,
          toPickedAmount: 0,
          totalToPickedAmount: 0,
        },
      };
    },
    computed: {
      columnList() {
        return [
          { type: 'checkbox', width: 50 },
          {
            title: this.$t('mcInboundEdit.column.sortNo'),
            field: 'sortNo',
            type: 'seq',
            width: 60,
          }, //序号
          { title: '行号', field: 'inboundPickNo', width: 60 },
          { title: this.$t('mcInboundEdit.column.productDesc'), field: 'productDesc', width: 200 }, //原材料描述
          { title: this.$t('mcInboundEdit.column.productNo'), field: 'productNo', width: 120 }, //原材料编码
          {
            title: this.$t('mcInboundEdit.column.ladingAmount'),
            field: 'ladingAmount',
            width: 120,
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.ladingAmount)}</span>];
              },
            },
          }, //原材料金额
          {
            title: this.$t('mcInboundEdit.column.ladingQuantity'),
            field: 'ladingQuantity',
            width: 120,
          }, //原材料数量
          {
            title: this.$t('mcInboundEdit.column.actualSendQuantity'),
            field: 'actualSendQuantity',
            width: 180,
          }, //实发数量
          {
            title: this.$t('mcInboundEdit.column.ladingUnit'),
            field: 'ladingUnit',
            width: 120,
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.getDictValueByType('basic_unit', row.ladingUnit)}</span>,
                ];
              },
            },
          }, //计数单位
        ];
      },
      goodsTableRules() {
        return {
          ladingQuantity: [
            {
              required: true,
              message: this.$t('salesBill.baseInfo.label.pleaseChooseWrite'),
              trigger: ['change', 'blur'],
            },
          ],
          businessChangingUnitPrice: [
            {
              required: true,
              message: this.$t('salesBill.message.businessChangingUnitPriceMsg'),
              trigger: ['change', 'blur'],
            },
          ],
        };
      },
    },
    created() {
      this.feeFormRules = {};
      this.storageLadingPickingDetailList = XEUtils.clone(this.storageLadingPickingDetail, true);
      this.storageLadingPicking = XEUtils.clone(this.storageLadingPickings, true);
      /*  this.storageLadingPicking = [
        {distributionInboundNo:'test1',instructionNo:'f90000006152',productDesc:'蛋白粉-杭州-2-',
          productNo:'20001183',ladingAmount:'10',externalContractNo:'wbht001',partnerNo:'HZHB0200002079',
          partnerName:'OLAM INTERNATIONAL LTD',ladingPrice:'10',ladingQuantity:'8',actualSendQuantity:'6',
          ladingUnit:'BBL',outboundStorageNo:'wtjg001',outboundStorageName:'委托加工仓库'
        }
      ] */
    },
    mounted() {
      this.editConfig = this.isEdit ? { trigger: 'click', mode: 'row' } : {};
      this.editConfigPickingDetail = this.$route.query.copy
        ? {}
        : this.editConfigFlag
        ? { trigger: 'click', mode: 'row' }
        : {};
    },
    methods: {
      toFixedNumber,
      //实发数量
      actualSendQuantityChange(val, scope) {
        const indexRow = this.storageLadingPicking.findIndex((item) => {
          return scope.row.inboundPickNo == item.inboundPickNo;
        });
        const addNum = [];
        this.storageLadingPickingDetailList.map((itemList) => {
          if (scope.row.inboundPickNo == itemList.inboundPickNo) {
            addNum.push(itemList.actualSendQuantity || 0);
          }
        });
        Promise.resolve(this.calculateAdd(addNum)).then((res) => {
          this.storageLadingPicking[indexRow].actualSendQuantity = res;
          if (
            this.basicData.deliveryMethod == 'JHFS04' ||
            this.basicData.deliveryMethod == 'JHFS05' ||
            this.basicData.deliveryMethod == 'JHFS06'
          ) {
            this.storageLadingPicking[indexRow].nonInvoiceQuantity =
              this.storageLadingPicking[indexRow].actualSendQuantity;
          } else {
            this.storageLadingPicking[indexRow].nonInvoiceQuantity = 0;
          }
          this.$emit('refreshData', this.storageLadingPicking);
        });
      },
      //业务入库批次拣配
      batchPicking() {
        const selections = this.$refs.goodsTable.getCheckboxRecords();
        if (selections.length != 1) {
          this.$message({
            showClose: true,
            message: this.$t('salesBill.message.selectOneMatching'),
            type: 'error',
          });
          return;
        }
        if (!selections[0].ladingQuantity || selections[0].ladingQuantity == '0') {
          this.$message({
            showClose: true,
            message: '原材料数量大于零的原材料行明细才可以拣配',
            type: 'error',
          });
          return;
        }
        const rowIndex = selections[0].inboundPickNo;
        this.$refs.batchPickingDialog.chooseGoods(selections, rowIndex, this.basicData);
      },
      //抛出表格数据
      exportTableData() {
        let storageLadingPickingList = this.$refs.goodsTable.getTableData().fullData;
        let storageLadingPickingDetailList = this.$refs.resultTable.getTableData().fullData;
        storageLadingPickingDetailList.map((item) => {
          const result = item;
          delete result.gmtCreate;
          return result;
        });
        let obj = {
          storageLadingPickingList,
          storageLadingPickingDetailList,
        };
        return obj;
      },
      //校验
      validateAll() {
        let formArr = ['goodsTable', 'resultTable']; //两个表格
        var resultArr = []; //用来接受返回结果的数组
        var _self = this;
        function checkForm(formName) {
          //封装验证表单的函数
          var result = new Promise(function (resolve, reject) {
            _self.$refs[formName].validate((valid) => {
              if (valid) {
                resolve();
              } else {
                reject();
              }
            });
          });
          resultArr.push(result); //push 得到promise的结果
        }
        formArr.forEach((item) => {
          //根据表单的ref校验
          checkForm(item);
        });
        Promise.all(resultArr)
          .then(function () {
            //都通过了
            return true;
          })
          .catch(function () {});
      },
      //接收拣配结果
      changeResult(arr, detailno) {
        let selections = this.$refs.goodsTable.getCheckboxRecords();
        let ladingAmount = 0; //原材料金额 = 所有拣配商品价格合计
        arr.forEach((item) => {
          if (item.batchNo) {
            item.inboundPickNo = detailno;
            item.productNo = item.productDetailNo;
            item.productDesc = item.productName;
            item.ladingUnitName = item.productUnitName;
            item.unit = item.productUnit;
            item.supplier = item.partnerName;
            item.businessContractUnitPrice = item.businessUnitPriceWithTax;
            item.businessPickingAmount = this.$cal.calCommon(
              item.businessUnitPriceWithTax,
              item.pickingQuantity,
              '*',
              'amount'
            );
            item.businessInboundBatchNo = item.batchNo;
            item.actualSendQuantity = item.pickingQuantity;
            item.currencyName = item.currencyTypeName;
            item.currencyCode = item.currencyTypeCode;
            // item.inboundPrice = item.inboundPrice;
            item.outboundStorageNo = item.storageNo;
            item.outboundStorageName = item.storageName;

            ladingAmount = this.$cal.accAdd(ladingAmount, item.businessPickingAmount);

            item = this.$baseRequest.assignObj(item);
          }
        });
        // 修改行信息原材料金额
        selections[0].ladingAmount = ladingAmount;
        // 相同行项目号的数据先筛选出去，再拼接数据
        const inboundPickNo = arr[0].inboundPickNo;
        this.storageLadingPickingDetailList = this.storageLadingPickingDetailList.filter((item) => {
          return item.inboundPickNo != inboundPickNo;
        });
        this.storageLadingPickingDetailList = this.storageLadingPickingDetailList.concat(arr);
        this.$emit('calcLadingPicking', this.$refs.goodsTable.getTableData().fullData);
      },
      //清空
      cleanResult() {
        this.storageLadingPickingDetailList = [];
      },
      refreshPage(obj) {
        this.storageLadingPicking = JSON.parse(JSON.stringify(obj));
      },
      // 接口加法计算
      calculateAdd(adds) {
        return new Promise((resolve, reject) => {
          this.$axios.post(API.GET_ADD_AMOUNT, { adds }).then((res) => {
            if (0 == res.data.code) {
              resolve(res.data.data);
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
              reject();
            }
          });
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .inputWidth {
    width: 100% !important;
  }
  .tabContent {
    padding: 10px;
    background-color: #fff;
  }
  .break-space {
    white-space: nowrap;
    line-height: 18px;
  }
</style>
<style lang="scss">
  // .el-select-dropdown__empty{
  //   display: none;
  // }
</style>
